var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.745,
    height: 25.745,
    viewBox: "0 0 25.745 25.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1243",
    "data-name": "Grupo 1243",
    transform: "translate(0)",
    opacity: 0.733
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    transform: "translate(0 17.164)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.291,
    cy: 4.291,
    r: 4.291,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.291,
    cy: 4.291,
    r: 3.791,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    transform: "translate(17.163 17.164)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.291,
    cy: 4.291,
    r: 4.291,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.291,
    cy: 4.291,
    r: 3.791,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    transform: "translate(17.163)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.291,
    cy: 4.291,
    r: 4.291,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.291,
    cy: 4.291,
    r: 3.791,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    transform: "translate(0)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.291,
    cy: 4.291,
    r: 4.291,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.291,
    cy: 4.291,
    r: 3.791,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.8548066fbf75d64a6d9bde8653aabd17.svg";
export { ForwardRef as ReactComponent };